import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface RecordTypeLabelProps {
  children: React.ReactNode;
  className?: string;
}

export const RecordTypeLabel = ({
  children,
  className,
}: RecordTypeLabelProps) => (
  <div
    className={classNames(
      "text-default text-xxs w-full px-5 py-2 font-semibold uppercase",
      className,
    )}
  >
    {children}
  </div>
);
